import DatePicker, { DatePicker$ChangeEvent } from "sap/m/DatePicker";
import { ValueState } from "sap/ui/core/library";

/**
 * Extends DatePicker to show validation error when user manually enters a badly formatted date.
 * Also, sets date format, so that value can be bound to a string in "yyyy-MM-dd" format, which is what .NET accepts as DateOnly.
 * The "value" property must be used for data binding, if you have a .NET DateOnly value.
 * @namespace akademika.akamont.customControls
 */
export default class CustomDatePicker extends DatePicker {
  init(): void {
    super.init();
    this.setValueFormat("yyyy-MM-dd");
    this.attachChange(this.handleDateChange);
  }

  static renderer = { apiVersion: 2 };

  handleDateChange(oEvent: DatePicker$ChangeEvent) {
    let isDateValid = oEvent.getParameter("valid");

    if (isDateValid) {
      this.setValueState(ValueState.None);
    } else {
      this.setValueState(ValueState.Error);
    }
  }
}
